import { LimeModal } from "@/Components/NextBase/LimeModal";
import { Button, ModalBody, ModalContent, ModalFooter } from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { useNavigate } from "react-router";

/**
 * Full-screen announcement of Tap to Pay on iPhone (Apple requirements 3.2,
 * 6.2). The hero slot takes the Toolkit's "Hero in-app banner"; copy changes
 * must come from Apple's Tap to Pay on iPhone Marketing Toolkit too.
 */
export function TapToPayAwarenessModal({
  productName,
  onClose,
}: {
  productName: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();

  function setUp() {
    onClose();
    navigate("/dashboard/integrations/terminals?tapToPay=enable");
  }

  return (
    <LimeModal isOpen onClose={onClose} size="full">
      <ModalContent className="pt-[var(--safe-area-top)] pb-safe">
        <ModalBody
          className="mx-auto flex w-full max-w-md flex-col justify-center gap-5 text-center"
          data-identifier="tap-to-pay-awareness"
        >
          <div
            aria-hidden
            className="aspect-[4/3] w-full rounded-large bg-default-100"
            data-identifier="tap-to-pay-awareness-hero"
          />
          <h2 className="font-semibold text-2xl">{productName}</h2>
          <p className="text-default-600">
            <Trans>
              Sprejemajte brezstična plačila s karticami, Apple Pay in drugimi
              digitalnimi denarnicami kar z iPhonom. Brez dodatnega terminala.
            </Trans>
          </p>
        </ModalBody>
        <ModalFooter className="mx-auto flex w-full max-w-md flex-col gap-2">
          <Button
            color="primary"
            data-identifier="tap-to-pay-awareness-set-up"
            onPress={setUp}
            size="lg"
          >
            <Trans>Nastavi zdaj</Trans>
          </Button>
          <Button
            data-identifier="tap-to-pay-awareness-later"
            onPress={onClose}
            variant="light"
          >
            <Trans>Kasneje</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </LimeModal>
  );
}
